import { cardBaseProps as s } from "../../card/src/Card.js";
import { dialogProps as o } from "../../dialog/src/dialogProps.js";
import { keysOf as r } from "../../_utils/vue/keysOf.js";
const e = Object.assign(Object.assign({}, s), o), m = r(e);
export {
  e as presetProps,
  m as presetPropsKeys
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/presetProps.js
// module id = 925
// module chunks = 41